<template>
  <div>
        <div v-if="isLoadingConversations" class="spinner-container">
          <div class="spinner"></div>
        </div>
        <div class="container-fluid overflow-auto">
          <div class="row">
          <div class="col-12 pt-3 pb-3 pl-4">
            <h3><i class="fa fa-headset"></i> Central Atendimento Geral</h3>
          </div>
          <div class="col-12 col-md-2 ml-auto">
                <defaultbutton
                  class="defaultbutton"
                  :onClick="() => onShowSearch()"
                  btnVariant="btn-third"
                  icon="fas fa-search"
                  text="Pesquisar"
                />
              </div>
        </div>
        <Conversations ref="conversations" class="atendimento-conversations"
        :conversations="conversations"
          @changeTab="handleTabChange"
          @sendUpdateOperator="updataOperator"
          @sendAssumeOperator="assumeConversation"
          @loading-changed="handleLoadingChanged"
          />
          <div class="row" v-show="conversationIsNull && allConversations.length === 0">
            <div class="col-12 pt-3 pb-3 pl-1">
              <h4 class="ml-5">Não possui atendimentos</h4>
          </div>
        </div>
        <div class="pagination-controls">
          <nav aria-label="Page navigation example">
            <ul class="pagination justify-content-center">
              <li class="page-item">
                <a @click="goToFirstPage" :disabled="filters.page <= 1" class="page-link" href="#">Primeira</a>
              </li>
              <li class="page-item">
                <a @click="previousPage" :disabled="filters.page <= 1" class="page-link" href="#">Anterior</a>
              </li>
              <li v-for="page in getPageRange()" :key="page" :class="['page-item', { 'active': filters.page === page }]">
                <a @click="goToPage(page)" class="page-link" href="#">{{ page }}</a>
              </li>
              <li class="page-item">
                <a @click="nextPage" :disabled="filters.page >= totalPages" class="page-link" href="#">Próximo</a>
              </li>
              <li class="page-item">
                <a @click="goToLastPage" :disabled="filters.page >= totalPages" class="page-link" href="#">Última</a>
              </li>
              <ul class="pagination justify-content-center">
                <span class="page-link">
                  Página {{ filters.page }} de {{ totalPages }}
                </span>
              </ul>
            </ul>
          </nav>
        </div>
        <SidebarSearchCentralAtendimento @search="onSearch" />
      </div>
  </div>
</template>
<script>
import Conversations from './components/conversations/Conversations.vue'
// import { JWTService } from '@/shared/services/jwt'

// import _ from 'lodash'

import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import SidebarSearchCentralAtendimento from '@/views/private/atendimento/central_atendimento_geral/components/conversations/SidebarCentralAtendimento.vue'
import defaultbutton from '@/components/UI/button/defaultButton.vue'

import AccountMixin from '@/store/module/account/mixin'
import SockJS from 'sockjs-client'
import Stomp from 'stompjs'
import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'Atendimento',
  components: {
    Conversations,
    SidebarSearchCentralAtendimento,
    defaultbutton
  },
  mixins: [AccountMixin],
  computed: {
  },
  data () {
    return {
      isLoadingConversations: false,
      conversationsSubscription: null,
      conversations: [],
      localConversations: [],
      allConversations: [],
      conversationSubscription: null,
      conversationDispatchesSubscription: null,
      conversation: {
        conversationId: null,
        identifier: null
      },

      isLoadingMessages: false,
      messages: [],
      stompClient: null,

      isLoading: false,
      conversationIsNull: false,
      isConnected: false,
      currentPage: 1,
      pageSize: 12,
      page: 1,
      totalPages: null,
      filters: {
        status: 'Aberto',
        operatorId: ['emptyOperator'],
        deptoId: ['emptyDepto'],
        botId: ['NDA'],
        page: 1,
        pageSize: 12,
        fetchImages: true
      }
    }
  },
  watch: {
    'conversation.conversationId': {
      deep: true,
      async handler (value) {
        if (!this.conversation.identifier) return

        await Promise.all([
          this.getMessages(value)
        ])

        this.subscribeToConversation(value)
        this.subscribeToConversationDispatches(value)
      }
    }
  },
  mounted () {
    this.connect()
  },
  beforeDestroy () {
    this.unsubscribeFromConversations()
    this.unsubscribeFromConversation()
    this.unsubscribeFromConversationDispatches()
    this.disconnect()
  },
  methods: {
    connect () {
      const socket = new SockJS(`${process.env.APIBaseBPM}/websocket`)
      this.stompClient = Stomp.over(socket)

      this.stompClient.connect({}, frame => {
        this.isConnected = true
        this.subscribeToConversations()
        this.getPages()
        this.getConversations()
      }, error => {
        this.isConnected = false
        console.error('Connection error: ' + error)
      })
    },
    disconnect () {
      if (this.stompClient !== null) {
        this.stompClient.disconnect()
      }
    },
    subscribeToConversations () {
      if (this.isConnected) {
        var topic = '/topic/central_atendimentos'

        this.conversationsSubscription = this.stompClient.subscribe(topic, this.onConversationsUpdated)
      }
    },
    onConversationsUpdated () {
      this.getConversations()
    },
    unsubscribeFromConversations () {
      if (this.conversationsSubscription !== null) {
        this.conversationsSubscription.unsubscribe()
        this.conversationsSubscription = null
      }
    },
    handleReadConversation (conversation) {
      const payload = {
        conversationId: conversation,
        _id: this.account.id
      }
      if (conversation === this.conversation.conversationId) {
        this.getConversations()
      }
      this.stompClient.send(`/app/conversations/readMessage`, {}, JSON.stringify(payload))
    },
    updatePagination () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize

      // Verifique se allConversations é um array antes de acessar conversations
      if (Array.isArray(this.allConversations)) {
        this.conversations = this.allConversations.slice(start, end)
        this.totalPages = Math.ceil(this.allConversations.length / this.pageSize)
      } else {
        console.error('allConversations não é um array ou está indefinido.')
        this.conversations = []
        this.totalPages = 0
      }
    },
    subscribeToConversation (conversationId) {
      if (this.isConnected) {
        this.unsubscribeFromConversation()
        const topic = `/topic/central_atendimento/${conversationId}`

        this.conversationSubscription = this.stompClient.subscribe(topic, this.onMessageReceived)
      }
    },
    unsubscribeFromConversation () {
      if (this.conversationSubscription !== null) {
        this.conversationSubscription.unsubscribe()
        this.conversationSubscription = null
      }
    },
    subscribeToConversationDispatches (conversationId) {
      if (this.isConnected) {
        this.unsubscribeFromConversationDispatches()
        const topic = `/topic/dispatches/${conversationId}`

        this.conversationDispatchesSubscription = this.stompClient.subscribe(topic, this.onMessageDispatched)
      }
    },
    unsubscribeFromConversationDispatches () {
      if (this.conversationDispatchesSubscription !== null) {
        this.conversationDispatchesSubscription.unsubscribe()
        this.conversationDispatchesSubscription = null
      }
    },
    refreshPage () {
      location.reload()
    },
    clearConversations () {
      this.conversations = []
    },
    goToPage (page) {
      this.filters.page = page
      this.clearConversations()
      this.getConversations()
    },

    previousPage () {
      if (this.filters.page > 1) {
        this.filters.page--
        this.clearConversations()
        this.getConversations()
      }
    },

    nextPage () {
      if (this.filters.page < this.totalPages) {
        this.filters.page++
        this.clearConversations()
        this.getConversations()
      }
    },

    goToFirstPage () {
      if (this.filters.page !== 1) {
        this.filters.page = 1
        this.clearConversations()
        this.getConversations()
      }
    },

    goToLastPage () {
      if (this.filters.page !== this.totalPages) {
        this.filters.page = this.totalPages
        this.clearConversations()
        this.getConversations()
      }
    },
    // Interaction methods
    handleTabChange () {
      this.conversations = []
    },
    async assumeConversation (payload) {
      loading.push()
      let hasOperator = false

      try {
        const requestConfig = {
          status: this.filters.status,
          operatorId: this.filters.operatorId,
          deptoId: this.filters.deptoId,
          // page: this.filters.page, // Use filters.page
          // pageSize: this.filters.pageSize,
          fetchImages: this.filters.fetchImages,
          botId: this.filters.botId,
          conversationId: [payload.conversationId]
        }
        const response = await AtendimentoRepository.GetConversations(requestConfig)
        const { status, data } = response
        if (status === 200) {
          hasOperator = data.length <= 0
        }

        if (hasOperator) {
          this.isLoadingConversations = false
          this.$bvToast.toast('Este atendimento já está com algum operador', {
            title: 'Atenção',
            variant: 'danger',
            autoHideDelay: 5000,
            appendToast: true
          })
          // this.getConversations()
          return
        }

        this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
        setTimeout(() => {
          this.$router.replace(`/atendimento?conversationId=${payload.conversationId}`)
          loading.pop()
        }, 2000)
      } catch (error) {
        console.error(error)
      } finally {
        setTimeout(() => {
          loading.pop()
        }, 2100)
      }
    },
    async getPages () {
      const requestConfig = {
        status: this.filters.status,
        operatorId: this.filters.operatorId,
        deptoId: this.filters.deptoId,
        botId: this.filters.botId
      }

      await AtendimentoRepository.GetPages(requestConfig)
        .then(response => {
          const { status, data } = response

          if (status === 200) {
            this.countsConversation = data.count
            this.totalPages = Math.ceil(data.count / this.pageSize)
          }
        })
        .catch(error => {
          console.error(error)
        })
    },
    async getConversations () {
      this.handleLoadingChanged(true)
      try {
        const requestConfig = {
          status: this.filters.status,
          operatorId: this.filters.operatorId,
          deptoId: this.filters.deptoId,
          page: this.filters.page, // Use filters.page
          pageSize: this.filters.pageSize,
          fetchImages: this.filters.fetchImages,
          botId: this.filters.botId
        }

        const response = await AtendimentoRepository.GetConversations(requestConfig)
        const { status, data } = response

        if (status === 200) {
          this.allConversations = data
          this.updatePagination() // Atualize a paginação
          this.conversationIsNull = this.conversations.length === 0
        } else {
          this.conversationIsNull = true
        }
      } catch (error) {
        console.log(error)
        this.conversationIsNull = true
      } finally {
        this.handleLoadingChanged(false)
      }
    },
    updataOperator (payload) {
      this.stompClient.send(`/app/conversations/updateOperator`, {}, JSON.stringify(payload))
      setTimeout(() => {
        this.$router.replace(`/atendimento?conversationId=${payload.conversationId}`)
      }, 2000)
    },
    handleLoadingChanged (isLoading) {
      this.isLoadingConversations = isLoading
    },
    getPageRange () {
      const totalPages = this.totalPages || 1
      const range = 5
      let startPage = Math.max(1, this.page - range)
      let endPage = Math.min(totalPages, this.page + range)

      if (endPage - startPage < range * 2) {
        if (startPage === 1) {
          endPage = Math.min(totalPages, startPage + range * 2)
        } else {
          startPage = Math.max(1, endPage - range * 2)
        }
      }

      return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)
    },
    onSearch (filters) {
      this.filters = filters
      this.$nextTick(() => {
        this.getPages()
        this.getConversations()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>

<style lang="scss" scoped>
.atendimento-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .atendimento-nav {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    padding: 0 1rem;
    margin-bottom: 5px;
    border-bottom: solid 1px #e6e6e6;
    background-color: #fff;

    span {
      color: #006a5b !important;
      font-weight: 700;
      font-size: 16px;
    }
  }

  .atendimento {
    display: flex;
    height: 100%;

    .atendimento-conversations {
      width: 20% !important;
      max-width: 20%;
      min-width: 300px;
    }

    .atendimento-chat {
      width: 60% !important;
      min-width: 300px;
    }

    .atendimento-detail {
      width: 20% !important;
      max-width: 25%;
      min-width: 300px;
    }
  }
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1BACA0;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/central_atendimento_geral/centralAtendimento.vue